<template>
  <div>そのページは存在しません。</div>
</template>

<script>
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { actions as colorThemeActions } from '@/vuex/modules/ui/colorTheme/constants'

export default {
  mixins: [setToolBarTypeLoginLp, setDrawerTypeLoginLp],
  created() {
    this.$store.dispatch(colorThemeActions.INITIALIZE)
  },
}
</script>

<style scoped></style>
